export enum ServiceCategoryType {
    ALL = 'All',
    DOG_GROOMING = 'Dog Grooming',
    CONSULTATION = 'Consultation',
    DAYCARE = 'Daycare',
    GROOMING_ADD_ONS = 'Grooming Add-Ons',
    FELINE_GROOMING = 'Feline Grooming',
    MOBILE = 'Mobile',
}
